<style>
#videoInspectionCardModal .v--modal-box.v--modal {
  min-height: 500px !important;
  min-width: 680px !important;
}
#videoInspectionCardModal #attr__wrapper .layout:not(#geometry-panel) {
  margin-top: 20px;
}
#videoInspectionCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#videoInspectionCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#videoInspectionCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#videoInspectionCardModal .v-select__selection,
#videoInspectionCardModal .v-select__slot input {
  font-size: 12px !important;
}
.btnDisabled {
  pointer-events: none !important;
  color: rgb(136, 136, 136) !important;
}
</style>

<template>
  <Modal
    modalName="videoInspectionCardModal"
    :title="`INSPEKCJA WIDEO O ID ${oid}`"
    :buttons="['']"
    :editing="editing"
    :print__left="true"
    :module="module"
    @closed="close"
    @opened="transformPolyCoords(), loadAttachments()"
    @print="printReport"
    @editingStart="startEditing"
    @editingCancel="cancelEditing"
    @editingSave="saveEditing"
  >
    <div style="height: 100%;">
      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
      >
        <v-tab>ATRYBUTY</v-tab>
        <v-tab-item>
          <v-card
            flat
            id="attr__wrapper"
          >
            <v-layout
              row
              wrap
              class="geometry-panel"
            >
              <v-flex
                xs4
                v-if="!videoInspectionData.geometry"
                style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
              >
                <v-icon
                  class="table__btn--green geometry-panel__add-btn"
                  @click="addGeometry"
                >add_circle</v-icon>
                <p
                  @click="addGeometry"
                  class="hover__pointer"
                >Dodaj geometrię</p>
              </v-flex>
              <v-flex
                xs4
                v-else
                style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
                :class="{btnDisabled: !editing}"
              >
                <v-icon
                  :class="{btnDisabled: !editing}"
                  class="table__btn--red geometry-panel__delete-btn"
                  @click="removeGeometry"
                >delete</v-icon>
                <p
                  class="hover__pointer"
                  @click="removeGeometry"
                >Usuń geometrię</p>
              </v-flex>
              <v-flex xs8>
                <v-layout
                  justify-space-between
                  id="geometry-panel"
                >
                  <p
                    v-if="videoInspectionData.geometry"
                    class="msg--padding"
                  >Geometria dodana</p>
                  <p
                    v-else
                    class="msg--padding"
                  >Brak dodanej geometrii</p>
                  <span v-if="videoInspectionData.geometry">
                    <v-icon
                      title="Przybliż do geometrii"
                      class="geometry-panel__zoom-btn"
                      @click="zoomToInspectionGeom"
                    >zoom_in</v-icon>
                  </span>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrawp
            >
              <v-flex xs5>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing"
                >
                  <template
                    :readonly="!editing"
                    v-slot:activator="{ on }"
                  >
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Data inspekcji"
                      prepend-icon="event"
                      :readonly="!editing"
                      @input="videoInspectionData.inspection_date = parseDate(computedDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="videoInspectionData.inspection_date"
                    @input="dateMenu = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="inspection_type"
                  v-model="videoInspectionData.inspection_type"
                  label="Typ inspekcji"
                  :readonly="!editing"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-autocomplete
                  v-model="videoInspectionData.address"
                  :items="addressItems"
                  :readonly="!editing"
                  :search-input.sync="search"
                  label="Adres"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  no-data-text="Rozpocznij wprowadzanie adresu"
                ></v-autocomplete>
              </v-flex>
              <v-spacer/>
            </v-layout>
            <v-layout
              row
              wrawp
            >
              <v-flex xs12>
                <v-textarea
                  name="description"
                  label="Opis inspekcji wraz ze wskazaniem lokalizacji pliku"
                  v-model="videoInspectionData.description"
                  :readonly="!editing"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-select
                  :items="users"
                  item-text="name"
                  item-value="id"
                  no-data-text="Brak użytkowników"
                  v-model="videoInspectionData.inspector_id"
                  :readonly="!editing"
                  label="Identyfikator/nazwa inspektora wykonującego inspekcję"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <v-tab v-if="featureEvents != undefined && featureEvents.hasOwnProperty('events')">ZDARZENIA ({{featureEvents.events_count}})</v-tab>
        <v-tab v-else>ZDARZENIA (0)</v-tab>
        <v-tab-item>
          <v-card flat>
            <Events
              style="margin-top: 15px"
              :featureEvents="featureEvents"
              :objectType="objectType"
              :module="module"
              :id="oid"
            />
          </v-card>
        </v-tab-item>

        <v-tab v-if="attachmentsArr.hasOwnProperty('data')">ZAŁĄCZNIKI ({{attachmentsArr.data.length}})</v-tab>
        <v-tab-item>
          <v-layout row>
            <v-flex
              xs12
              v-if="$can('read', 'inspections_attachments') || $can('edit', 'inspections_attachments')"
            >
              <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
              <div v-if="ifAttachments.hasOwnProperty('data') && ifAttachments.data.length > 0">
                <li
                  class="list__container--el"
                  v-for="(index, key) in attachmentsArr.data"
                  :key="key"
                >
                  <span>{{index.id}} - {{index.filename}}</span>
                  <span>
                    <v-icon
                      @click="downloadAttachment(index.id, index.filename)"
                      small
                      title="Pobierz załącznik"
                      v-if="$can('read', 'inspections_attachments') || $can('edit', 'inspections_attachments')"
                    >cloud_download</v-icon>
                    <v-icon
                      @click="deleteAttachment(index.id)"
                      small
                      title="Usuń załącznik"
                      v-if="$can('edit', 'inspections_attachments')"
                    >delete</v-icon>
                  </span>
                </li>
              </div>
              <div v-else>
                <p class="font--primary">Brak powiązanych załączników</p>
              </div>
              <AddAttachment
                v-show="editing"
                ref="videoInspectAttach"
                @attachmentAdded="loadAttachments()"
                @attachmentDeleted="loadAttachments()"
                @confDialogOpened="triggerDialogAttach"
                @fileAdded="updateList"
                @fileRemoved="updateListRemove"
                :id_="oid"
                :objectType="objectType"
                :objectTable="objectTable"
                :auto="true"
                :module="module"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            v-show="editing"
          >
            <v-subheader class="font--primary">ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader>
          </v-layout>
          <v-layout
            row
            wrap
            style="height: 90%"
            v-show="editing"
          >
            <v-flex
              xs12
              style="height:100%"
            >
              <DatabaseAttachments
                :objectIdCard="oid"
                :objectTableCard="objectTable"
                :objectTypeCard="objectType"
                @attachmentAdded="loadAttachments"
              />
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>

    </div>
  </Modal>
</template>

<script>
import AddAttachment from "../../../shared/AddAttachment";
import DatabaseAttachments from "../../table/attachments/DatabaseAttachments";
import Events from "../../../shared/Events";
import Modal from "../../../shared/Modal";
import moment from "moment";
import debounce from "lodash/debounce";
import _ from "lodash/wrapperLodash";

export default {
  components: {
    AddAttachment,
    DatabaseAttachments,
    Events,
    Modal
  },
  data: vm => ({
    addressItems: [],
    attachmentsArr: [],
    attachmentsNumber: 0,
    dateMenu: false,
    editing: false,
    eventsNumber: 0,
    inspection_type: [],
    isDrawing: false,
    module: 'videos',
    objectType: "video",
    objectTable: "video",
    oid: undefined,
    search: null,
    videoInspectionData: {
      address: undefined,
      inspection_date: new Date().toISOString().substr(0, 10),
      dateFormatted: undefined,
      description: undefined,
      inspection_type: undefined,
      inspector_id: undefined,
      geometry: undefined,
      geometry4326: undefined,
      net_type: undefined
    },
    videoInspectionDataCopy: {}
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    computedDateFormatted() {
      if(this.videoInspectionData.hasOwnProperty('inspection_date')) {
        return this.formatDate(this.videoInspectionData.inspection_date.slice(0, 10))
      }
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        };
      });
    }
  },
  watch: {
    "videoInspectionData.inspection_date"(val) {
      if(this.videoInspectionData) {
        this.videoInspectionData.dateFormatted = this.formatDate(this.videoInspectionData.inspection_date)
      }
    },
    search (val) {
      val && val !== this.videoInspectionData.address && this.querySelections(val)
    }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.objectType);
      this.isDrawing = true;
    },
    assignGeomToInspection(polygonData) {
      if(polygonData.length > 1) {
        this.videoInspectionData.geometry = polygonData[0];
        this.videoInspectionData.geometry4326 = polygonData[1];
      } else {
        this.videoInspectionData.geometry4326 = polygonData[0];
      }
    },
    cancelEditing() {
      this.editing = false;
      this.videoInspectionData = Object.assign({}, this.videoInspectionDataCopy);
      this.$root.$emit(
        "addMapLayer",
        [this.videoInspectionData.geometry, this.videoInspectionData.geometry.coordinates],
        "video"
      );
    },
    close() {
      this.removeGeometry();

      this.dateMenu = false;
      this.editing = false;
      this.inspection_type = [];
      this.videoInspectionData = {};
      this.isDrawing = false;
      this.oid = undefined;

      this.objectType = "video";
      this.objectTable = "video";
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.videoInspectAttach.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    deleteAttachment(attachmentId) {
      this.$refs.videoInspectAttach.deleteAttachment(attachmentId);
    },
    formatDate(date) {
      if(!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    getDictValues(field, table, schema) {
      let payload = {
        schema: schema,
        table: table,
        column: field
      };
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if(!r) {
          return;
        } else {
          this[field] = r.values;
        }
      });
    },
    loadData(data) {
      this.oid = data.id;
      if(this.users.length < 1) {
        this.$store.dispatch("getUsers");
      }

      if(data.type == 'videos') {
        this.videoInspectionData = Object.assign({}, data.properties.properties);
        this.$set(this.videoInspectionData, 'geometry', data['properties']['geometry'])
        this.loadAttachments();

        let payload = {
          object_id: this.oid,
          object_type: 'video',
          limit: 5,
          events_count: true
        };

        this.$store.commit("setFeatureEvents", {});
        this.$store.dispatch("getFeatureEvents", payload).then(() => {
          this.$root.$emit('setAllFeatures');
          this.$root.$emit('loadEventsOnPage');
        })
      } else {
        this.videoInspectionData = Object.assign({}, data.properties);
        this.$set(this.videoInspectionData, 'geometry', data['geometry'])
        if (data.properties.address) {
          this.addressItems.push(data.properties.address)
        }
      }
      const payloads = [
        {
          schema: "registry",
          table: this.objectType,
          column: "inspection_type"
        }
      ]
      payloads.forEach(payload => {
        this.getDictValues(payload.column, payload.table, payload.schema)
      })
      if(data.type != 'videos') {
        this.$root.$emit('zoomToArea', [data.geometry.coordinates]);
        this.$root.$emit(
          "addMapLayer",
          [data.geometry, data.geometry.coordinates],
          "video"
        );
      }
    },
    loadAttachments() {
      let payload = {
        object_type: this.objectType,
        layer: this.objectTable,
        oid: this.oid
      };
      this.$store
        .dispatch("getAttachmentsForObject", payload)
        .then(success => {
          if(success) {
            this.attachmentsArr = this.$store.getters.getObjectAttachments;
          }
        });
    },
    transformPolyCoords() {
      this.$root.$emit('transformPolygon', this.videoInspectionData.geometry);
    },
    parseDate(date) {
      if(!date) return null

      const [day, month, year] = date.split('-')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    printReport() {
      this.show('videoReportModal')
      this.$root.$emit('openVideoReportSettings', this.oid)
    },
    removeGeometry() {
      this.$root.$emit('removeMapLayer')
      if(this.videoInspectionData) {
        this.videoInspectionData.geometry = undefined;
      }
    },
    saveEditing() {
      this.$set(this.videoInspectionData, 'geometry', this.videoInspectionData['geometry4326'])
      let payload = {
        body: this.videoInspectionData,
        oid: this.oid
      };
      delete payload.body.dateFormatted;
      delete payload.body.geometry4326;
      // payload.body.inspection_date = payload.body.inspection_date + "T00:00:00"

      this.$store.dispatch("editVideoInspectionCard", payload).then(r => {
        if(r) {
          // this.$refs.videoInspectAttach.processQueueDropzone();
          this.editing = false;
          this.$root.$emit("edited_video_inspection"); //update registry
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      })
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    startEditing() {
      this.editing = true;
      this.videoInspectionDataCopy = Object.assign({}, this.videoInspectionData);
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      this.attachmentsNumber = this.$refs.videoInspectAttach.$refs.attachmentDropzone.getQueuedFiles().length + 1;
    },
    updateListRemove() {
      this.attachmentsNumber = this.$refs.videoInspectAttach.$refs.attachmentDropzone.getQueuedFiles().length;
    },
    querySelections: _.debounce(function (val) {
        const self = this;
        let payload = {
          table: 'address',
          term: val
        };
        this.$store.dispatch("getObject", payload).then(r => {
          self.addressItems = [];
          for(let el of r) {
            self.addressItems.push(el.label);
          }
        });
      }, 500),
    zoomToInspectionGeom() {
      this.$root.$emit('zoomToArea', [this.videoInspectionData.geometry.coordinates]);
    }
  },
  mounted() {
    this.$root.$on("loadVideoInspection", this.loadData);
    this.$root.$on('newGeomAdded', this.assignGeomToInspection);
    this.$root.$on('newpolygonGeom', this.assignGeomToInspection);
    this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
    moment.locale("pl");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/video/modals/VideoInspectionCard.vue